export enum COMPANY_DETAIL_PAGE_TYPE {
  create = 'create',
  view = 'view',
  edit = 'edit'
}

export enum CATEGORY_DETAIL_PAGE_TYPE {
  create = 'create',
  edit = 'edit'
}

export enum BLOG_DETAIL_PAGE_TYPE {
  create = 'create',
  view = 'view',
  edit = 'edit'
}

export enum MONTH {
  January = 'January',
  February = 'February',
  March = 'March',
  April = 'April',
  May = 'May',
  June = 'June',
  July = 'July',
  August = 'August',
  September = 'September',
  October = 'October',
  November = 'November',
  December = 'December'
}
